<template>
    <div v-if="loader" class="preloader active"></div>
    <div v-else class="cart-wrapper row">
        <template v-if="count > 0">
            <div class="col-12 col-lg-8 ">
                    <cart-positions
                        :positions = positions
                        :currency = currency
                    />
            </div>
            <div class="col-12 mt-5 mt-lg-0 col-lg-4 ">
                <div class="cart-side">
                    <cart-total
                        :policy = false
                        :currency = currency
                        :price = price
                        :linkButton="'/checkout'"
                    />
                </div>
            </div>
        </template>
        <div v-else class="col-12 cart-empty">
            <h3>Корзина пуста</h3>
            Воспользуйтесь поиском, чтобы найти всё что нужно.
        </div>
    </div>
</template>
<script>

    import CartPositions from '../blocks/CartPositions.vue';
    import CartTotal from '../blocks/CartTotal.vue';
    export default {
        name: 'Cart',
        components: {
            CartPositions, CartTotal
        },
        props: {},
        data: () => ({
            loader: true,
            currency: 'р',
            positions: {},
        }),
        async mounted() {
            if (!Object.keys(this.$store.getters.cartItems).length) {
                await this.$store.dispatch('getCartItems');
            }

            this.positions = this.$store.getters.cartItems;

            if (this.positions.length) this.currency = this.positions[0].currency;

            if (!Object.keys(this.$store.getters.price).length) {
                await this.$store.dispatch('getPrice');
            }

            this.loader = false;
        },
        computed: {
            cartItems() {
                return this.$store.getters.cartItems;
            },
            price() {
                return this.$store.getters.price;
            },
            count() {
                return this.positions.filter(s => s.remove == false).length;
            }
        },
        watch: {
            cartItems: function (val) {
               this.positions = val;
            },
        },
        methods: {

        }
    }
</script>
